module.exports = __webpack_public_path__ + "img/charging3.b64100dd.png";